import { render } from "./SearchServicesDGII.vue?vue&type=template&id=3d4d70bb"
import script from "./SearchServicesDGII.vue?vue&type=script&lang=js"
export * from "./SearchServicesDGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__